import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './CookieBanner.module.css';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.banner}>
        <div className={styles.icon}>🍪</div>
        <div className={styles.content}>
          <p className={styles.text}>
            Мы используем файлы cookie для улучшения работы сайта и анализа трафика. Продолжая использовать сайт, вы соглашаетесь с нашей{' '}
            <Link to="/privacy" className={styles.link}>Политикой конфиденциальности</Link>.
          </p>
        </div>
        <div className={styles.buttons}>
          <button className={styles.accept} onClick={handleAccept}>
            Принять
          </button>
          <button className={styles.decline} onClick={handleDecline}>
            Отклонить
          </button>
        </div>
      </div>
    </div>
  );
}
